function getFullPageTitle(t, title) {
	return [title, 'Four Seasons Hotels and Resorts', 'Luxury Hotels']
		.filter(Boolean)
		.map(t)
		.concat(['Four Seasons'])
		.join(' | ');
}

export default getFullPageTitle;
